document.addEventListener('DOMContentLoaded', () => {
  const heroBanner = document.querySelector('.hero-banner__content-wrapper');
  const isMobile = window.innerWidth <= 768;

  if (!isMobile || !heroBanner) return;

  const updateChatButtonVisibility = (chatButton) => {
    const rect = heroBanner.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const visibleHeight = Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));
    const visibilityRatio = visibleHeight / rect.height;
    chatButton.style.opacity = visibilityRatio >= 0.75 ? '0' : '1';
  };


  const intervalId = setInterval(() => {
    const chatButton = document.getElementById('chat-button');
    if (!chatButton) return;

    clearInterval(intervalId);
    updateChatButtonVisibility(chatButton);
    window.addEventListener('scroll', updateChatButtonVisibility.bind(this, chatButton));
  }, 50);
});
